import { render } from "./MediaViewer.vue?vue&type=template&id=70e92607&scoped=true"
import script from "./MediaViewer.vue?vue&type=script&lang=js"
export * from "./MediaViewer.vue?vue&type=script&lang=js"

import "./MediaViewer.vue?vue&type=style&index=0&id=70e92607&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e92607"]])

export default __exports__